/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createPi } from '../../factoriesAny.js';
export var piDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createPi: createPi
};